import React from 'react';
import { useSoundEffects } from '@/hooks/useSoundEffects';
import SoundIcon from '../Icons/SoundIcon';
import SoundOffIcon from '../Icons/SoundOffIcon';

const DSoundSettings = ({ className = '', asMenuItem = false, active = false }) => {
  const { soundConfig, updateSoundConfig } = useSoundEffects();

  const toggleSound = () => {
    updateSoundConfig({
      enabled: !soundConfig.enabled
    });
  };

  if (asMenuItem) {
    const actionLabel = soundConfig.enabled ? 'Sound Off' : 'Sound On';
    const ActionIcon = soundConfig.enabled ? SoundOffIcon : SoundIcon;

    return (
      <button
        onClick={toggleSound}
        className={`sound-settings-button ${
          active ? 'bg-[var(--dt-color-element-5)]' : ''
        } flex justify-between text-[var(--dt-color-element-100)] items-center gap-size1 py-size1 px-size2 rounded-size1 w-full ${className} border-b border-grey-5`}
      >
        <p className="text-base font-regular tracking-tight">
          {actionLabel}
        </p>
        <ActionIcon className="w-5 h-5 text-black" />
      </button>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <button
        onClick={toggleSound}
        className="p-2 rounded-full"
        title={soundConfig.enabled ? 'Sound On' : 'Sound Off'}
      >
        {soundConfig.enabled ? (
          <SoundIcon className="w-5 h-5 text-black" />
        ) : (
          <SoundOffIcon className="w-5 h-5 text-black" />
        )}
      </button>
    </div>
  );
};

export default DSoundSettings;
